const user = require('./user.service')
const otp = require('./otp.service')
const API = require('./api.utils')
const consultation = require('./consulatation.service')
const appointments = require('./appointment.service')
const file = require('./file.service')
const marketplace = require('./marketplace')
const alerts = require('./alert.service')
const kyc = require('./kyc-service')
const prescription = require('./prescription.service')
const hospital = require('./hospital-admin.service')
const group = require('./group.service')
const ratings = require('./rating-service')
const partner = require('./partner.service')
const icd = require('./icd.service')
const specification = require('./specification-service')
const chat = require('./chat.service')
const plan = require('./plan.service')
const coupon = require('./coupon-service')
const setting = require('./setting.service')
const shorturl = require('./shorturl.service')
const trustgate = require('./trustgate-service')

module.exports = {
  user,
  otp,
  API,
  consultation,
  appointments,
  file,
  marketplace,
  alerts,
  kyc,
  prescription,
  hospital,
  group,
  ratings,
  partner,
  icd,
  specification,
  chat,
  plan,
  coupon,
  setting,
  shorturl,
  trustgate,
}
